import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Dropdown,
  Tabs,
  Tab,
} from "react-bootstrap";
import openSocket from "socket.io-client";
import { useAuth } from "../../hooks/useAuth";
import { isEmpty, set } from "lodash";
import { useMutation, useQuery } from "react-query";
import {
  fetchActionsUtil,
  paginationOptions,
  convertToBaseCurrency,
} from "../../utils/helpers";
import { endOfToday, format, parse, startOfToday } from "date-fns";
import currency from "currency.js";
import useDebounce, { useCurrencies, useQueryParams } from "../../utils/hooks";
import { toast } from "react-toastify";
import { FilterIcon } from "../Icons";
import NoTableItem from "../utils/NoTableItem";
import ModalLoader from "../utils/ModalLoader";
import { IsPrivileged } from "../DisplayChildElement";
import queryString from "query-string";
import RsDateRangePicker from "../utils/RsDateRangePicker";
import ReactPaginate from "react-paginate";
import CachedIcon from "mdi-react/CachedIcon";
import ConfirmDialog from "../ConfirmDialogue";

import "../../assets/scss/reports/cashbook.scss";
import { appSettings } from "../../config";
import printJS from "print-js";
import { useStoreState } from "easy-peasy";
import moment from "moment";
import ConvertQuantity, { formatQuantity } from "../utils/ConvertQuantity";
// import qz from "qz-tray";

const socketType = {
  RESTAURANTORDER: "restaurantorder",
};
async function playSound(status) {
  try {
    const audio =
      status === "pending" ? new Audio("/new.mp3") : new Audio("/cancel.mp3");

    audio?.play();
  } catch (error) {
    console.log(error);
  }
}

const speakText = text => {
  if (!text) return;

  const utterance = new SpeechSynthesisUtterance(text);

  // Optional settings
  utterance.rate = 1; // Speed (0.5 - 2)
  utterance.pitch = 1; // Pitch (0 - 2)
  utterance.volume = 1; // Volume (0 - 1)

  window.speechSynthesis.cancel(); // stop ongoing speech
  window.speechSynthesis.speak(utterance);
};

const RestaurantMenuOrderNotification = () => {
  const { backendUrl } = useAuth();
  const [stashId, setStashId] = useState("");
  const [table, setTable] = useState([]);
  const { prevailingCurrencySymbol } = useCurrencies();
  const [updateOrderId, setUpdateOrderId] = useState("");
  const [notificationData, setNotificationData] = useState({});
  const [currentId, setCurrentId] = useState("");
  const generalSettings = useStoreState(state => state.generalSettings);
  const { isIronRod } = useAuth();
  const itemMeasurements = useStoreState(state => state.itemMeasurements);
  const uomConversions = useStoreState(state => state.uomConversions);

  // Unlock audio on first user interaction after document is ready
  useEffect(() => {
    const unlockAudio = () => {
      try {
        const context = new (window.AudioContext ||
          window.webkitAudioContext)();
        const buffer = context.createBufferSource();
        buffer.connect(context.destination);
      } catch (error) {
        console.log("Audio context unlock failed:", error);
      }
    };

    // Wait for document to be ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        document.addEventListener("click", unlockAudio, { once: true });
      });
    } else {
      // Document already loaded
      document.addEventListener("click", unlockAudio, { once: true });
    }

    return () => document.removeEventListener("click", unlockAudio);
  }, []);
  const initialFilterParams = {
    status: "pending",
    startDate: format(startOfToday(), "yyyy-MM-dd"),
    endDate: format(endOfToday(), "yyyy-MM-dd"),
    enableDateRange: true,
    stashId: "",
    stash: "",
  };
  const [currentPrint, setCurrentPrint] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
    page: 1,
    limit: 40,
  });

  const { data, refetch, isLoading } = useQuery(
    ["GET_PENDING_RESTAURANT_ORDERS", queryParams, stashId],
    () =>
      fetchActionsUtil(
        `${backendUrl}/api/items/get-restaurant-order?${queryString.stringify(
          queryParams
        )}`,
        "GET"
      ),
    {
      onSuccess: async ({ data = [] }) => {
        const items = data?.map(el => {
          const item = JSON.parse(el.items);

          const totalAmount = item?.reduce(
            (acc, curr) => acc + Number(curr?.SubTotal),
            0
          );
          const staff = el?.staff ? JSON.parse(el?.staff) : null;

          return {
            ...el,
            items: item,
            totalAmount: totalAmount,
            staff,
          };
        });

        const theVeryItem = items?.find(
          item => item?.stash_id === notificationData?.stash_id
        );

        console.log(
          "this is a ----- ",

          {
            sound: generalSettings?.enableRestaurantBeepSound,
            print: generalSettings?.enableAutoRestaurantOrderPrinting,
          }
        );

        !isEmpty(notificationData) &&
          ["pending"].includes(notificationData?.status) &&
          generalSettings?.enableRestaurantBeepSound &&
          (await playSound(notificationData?.status));
        setNotificationData({});

        setTable(items);
        if (
          !isEmpty(theVeryItem) &&
          generalSettings?.enableAutoRestaurantOrderPrinting
        ) {
          handlePrint(theVeryItem, true);
        }
      },
      keepPreviousData: true,
    }
  );
  const { data: canceledOrder } = useQuery(
    ["GET_CANCELED_ORDER", currentId, stashId],
    () =>
      fetchActionsUtil(
        `${backendUrl}/api/items/get-restaurant-order-single?stashId=${currentId}`,
        "GET"
      ),
    {
      enabled: !!currentId,
      onSuccess: async ({ data = [] }) => {
        const items = data?.map(el => {
          const item = JSON.parse(el.items);

          const totalAmount = item?.reduce(
            (acc, curr) => acc + Number(curr?.SubTotal),
            0
          );
          const staff = el?.staff ? JSON.parse(el?.staff) : null;

          const newItem = {
            ...el,
            items: item,
            totalAmount: totalAmount,
            staff,
          };
          return newItem;
        });

        if (currentId) {
          !isEmpty(notificationData) &&
            ["canceled"].includes(notificationData?.status) &&
            (await playSound(notificationData?.status));
          setNotificationData({});

          const stashItems = items?.filter(el => el?.stash_id === currentId);
          let description = `
  <div>
  <p>The following orders have been canceled:</p>
      <div className=" row ">
    <p style="margin-bottom: 10px;" ><b>Table No. ${
      stashItems[0]?.tableNumber
    }</b></p>
    <div className="fw-bold  " style="margin-bottom: 10px;">Order No: ${
      stashItems[0]?.id
    }</div>
    <div className="fw-bold " style="margin-bottom: 10px;">Sales Rep: ${
      stashItems[0]?.staff?.Name
    }</div>
    <div className="fw-bold " style="margin-bottom: 10px;">Staff ID: ${
      stashItems[0]?.staff?.Staff_ID
    }</div>
      ${stashItems
        ?.map(
          el => `
            <div className="card p-2 mb-3" style=" font-size: 1.1rem; ">

              <div className="d-flex justify-content-between mb-2"><span> <b>Items </b></span>  <span> <b>Quantity </b></span></div>
              ${el?.items
                ?.map(
                  item => `
                    <div className="d-flex justify-content-between">
                      <span> <b>${item?.Item_Name} </b></span>
                      <span> <b>${formatQuantity({
                        quantity: item?.Quantity,
                        desc: item?.Item_Desc,
                        uomId: item?.uomId,
                        convertNow: true,
                        itemMeasurements,
                        uomConversions,
                        isIronRod,
                      })}</b></span>
                    </div>
                  `
                )
                .join("")}
            </div>
          `
        )
        .join("")}
    </div>
  </div>
`;

          await ConfirmDialog({
            type: "danger",
            title: "Canceled Orders",
            description,
            choice: false,
          });

          refetch();

          setNotificationData({});

          setCurrentId("");
        }
      },
    }
  );

  const updateMutation = useMutation(
    payload =>
      fetchActionsUtil(
        `${backendUrl}/api/items/update-get-restaurant-order`,
        "POST",
        "",
        payload
      ),
    {
      onSuccess: () => {
        toast.success("Done");
        setUpdateOrderId("");

        refetch();
      },
      onError: ({ message }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );
  useEffect(() => {
    const socketClient = openSocket(backendUrl);

    socketClient.on("connect", () => {
      console.log("Check version socket is on");
    });

    socketClient.on(
      `${socketType.RESTAURANTORDER}-${socketType.RESTAURANTORDER}`,
      ({ data }) => {
        if (data?.status === "canceled") {
          setCurrentId(data?.stash_id);
        }
        let currentStatus = filterParams.status;

        if (!isEmpty(data)) {
          setNotificationData(data);
          setStashId(new Date().getTime());
          // setFilterParams({
          //   ...filterParams,
          //   status: currentStatus,
          //   stashId: "",
          //   stash: new Date().getTime(),
          // });
        }
      }
    );

    return () => {
      socketClient.off(
        `${socketType.RESTAURANTORDER}-${socketType.RESTAURANTORDER}`
      );
      socketClient.off("connect");
      socketClient.disconnect();
    };
  }, [backendUrl]);

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams, setQueryParams]);

  const customStyles = {
    primaryBlue: "#2463ae",
    darkBlue: "#0a4a95",
    blackPrimary: "#0f172a",
    blackSecondary: "#334155",
    blackSubtle: "#94a3b8",
    light: "#e2e8f0",
    lighterPale: "#f8faff",
    bluePale: "#ecf4fe",
    baseWhite: "#ffffff",
    baseGrey30: "#ced8e1",
    baseGrey40: "#a7b9cb",
    baseGrey60: "#788898",
    lightBlue2: "#d8e6f5",
  };

  const handleUpdateStatus = payload => {
    setUpdateOrderId(payload.id);
    updateMutation.mutate(payload);
  };

  const filterByDateRange = date => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };
  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };
  const TabButton = ({ id, label, icon: Icon, isActive, onClick }) => (
    <div
      role="button"
      className={`d-flex align-items-center gap-2 px-4 py-3 rounded-3 border-0 transition-all`}
      onClick={onClick}
      style={{
        backgroundColor: isActive ? "#2463ae" : "#ffffff",
        color: isActive ? "#ffffff" : "#334155",
        boxShadow: isActive
          ? "0 4px 15px rgba(36, 99, 174, 0.3)"
          : "0 2px 8px rgba(0,0,0,0.08)",
        cursor: "pointer",
        transform: isActive ? "translateY(-1px)" : "none",
        borderLeft: isActive ? "none" : "4px solid transparent",
        borderLeftColor:
          !isActive && id === filterParams?.status ? "#2463ae" : "transparent",
      }}
    >
      {Icon && <Icon size={18} />}
      <span className="fw-semibold">{label}</span>
    </div>
  );

  const printInvoice = async payload => {
    if (
      payload.currency &&
      payload.currency !== generalSettings?.prevailingCurrency
    ) {
      payload = convertToBaseCurrency({
        data: payload,
        conversionAmount: payload.conversionAmount,
      });
    }
    /*  console.log("JJ", payload);
        return; */
    // const isThermalPrinter =
    //   appSettings.printerType?.toLowerCase() ===
    //   "Thermal Printer"?.toLowerCase();

    let response = await fetch(
      `${backendUrl}/api/invoice/view-invoice-for-none-posted-transactions?thermalPrinter=true`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      // alert(JSON.stringify(response));
      throw new Error(JSON.stringify(response));
    }
    const res = await response.json();
    return res;
  };
  const printDirectInvoice = async payload => {
    if (
      payload.currency &&
      payload.currency !== generalSettings?.prevailingCurrency
    ) {
      payload = convertToBaseCurrency({
        data: payload,
        conversionAmount: payload.conversionAmount,
      });
    }
    /*  console.log("JJ", payload);
        return; */
    // const isThermalPrinter =
    //   appSettings.printerType?.toLowerCase() ===
    //   "Thermal Printer"?.toLowerCase();

    let response = await fetch(
      `${backendUrl}/api/invoice/print-direct?thermalPrinter=true`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      // alert(JSON.stringify(response));
      throw new Error(JSON.stringify(response));
    }
    const res = await response.json();
    return res;
  };

  async function handlePrint(data, printDirectly = false) {
    let values = data || {};

    const tableData = values?.items;
    const subTotal = values?.totalAmount;
    const amountDue = values?.totalAmount;
    const amount = values?.totalAmount;
    const customerData = JSON.parse(values?.customerData);

    let customer = !isEmpty(customerData)
      ? customerData
      : {
          numberPrefix: null,
          currentNumber: null,
          Cust_ID: "",
          FirstName: "",
          MiddleName: "",
          LastName: customerData?.customer || "",
          DOB: "",
          PhoneNo1: "",
          PhoneNo2: null,
          CompanyAddress: "",
          ContactAddress: "",
          Office_PhoneNo: null,
          Email: "",
          Name_Add_work: null,
          Name_Add_sch: null,
          Highest_Qual: null,
          Name_Institution: null,
          Year_attained: null,
          How_Did_Know: "",
          TransType: "",
          Product_Int1: "None",
          Product_Int2: "None",
          FollowUpComment: "",
          DateLog: "",
          PhotoPath: null,
          Branch: "",
          Dept: "Sales",
          password: "",
          Gender: null,
          Post_Time: "",
          state: null,
          LGA: null,
          Group: "",
          referal_EmployeeID: null,
          verifyToken: null,
          onlineStoreInventorySource: "",
          onlineStoreInventorySourceName: "",
          country: null,
          customerApprovePendingOnlineOrders: false,
          Staff_ID: null,
        };

    const initialvalue = {
      orderStatus: values?.status,
      staff: values?.staff,
      type: "order",
      orderId: values?.id,
      tableNumber: data.tableNumber,

      items: tableData,
      deliveryInformation: [
        {
          Vendor_ID: "",
          Vendor_Name: "",
          ServiceChargePerLitre: 0,
          Volume: 0,
          Total: 0,
          DriverName: "",
          TruckNumber: "",
          InhouseLoading: false,
          VolumeLoaded: 0,
          VolumeSupplied: 0,
          ShortageVolume: 0,
          EmployeeID: "",
        },
      ],
      taxType: "None",
      creditLine: "",
      PaymentType: "Cash",
      proformaNumber: "",
      splitPaymentType: "",
      printWaybill: true,
      salesDate: moment(),
      invoiceCat: "",
      OverwriteOfficer: "Retail",
      chequeNumber: "",
      BankName: "",
      cashAmount: "",
      sendEmail: false,
      printReciept: true,
      dueIn: "",
      pendingTransaction: "",
      supplyNow: false,
      ShipTo: customer?.LastName || "Walk-In",
      customerBalance: "",
      amountToPayFromCustomerCredit: "0",
      printer: appSettings.printerType,
      posCharge: 0,
      loadingCharge: "",
      offloadingCharge: "",
      isBatchStandard: appSettings.isBatchStandard,
      transportCharge: "",
      Sale_Rep: "",
      Sale_Rep_Name: "",
      shippingCost: 0,
      otherCharges: 0,
      splitPaymentCardArray: [
        {
          amount: "",
          bank: "",
          posCharge: "",
          fixedAmount: "",
        },
      ],
      splitDirectBankTransferArray: [
        {
          amount: "",
          bank: "",
        },
      ],
      splitPaymentChequeArray: [
        {
          amount: "",
          bank: "",
          chequeNumber: "",
        },
      ],
      Bar_Code: "",
      currency: generalSettings?.prevailingCurrency,
      linkedPaymentID: "",
      jobNumber: "",
      poNumber: "", // GA
      milestone: "",
      conversionAmount: generalSettings.dollarInBaseCurrency,
      poNumber: "",
      lockBank: false,
      itemSearchCriteria: "Item_Code",
      amountFromCustomerBalance: 0,
      bankOnInvoice: "",
      taxes: [],
      generalDiscountType: "Fixed",
      generalDiscount: 0,
      generalDiscountPercentage: "",
      selectedAccountToPost: null,
      amountPaid: 0,
      summaryFromMultiplePayments: {},
      subTotal,
      discount: 0,
      amountDue,
      profit: "0",
      balance: "0.00",
      amount,
      customer: customer,
      taxValue: tableData[0]?.taxValue || "0.000",
      costOFSales: amount,
      salesIncome: 0,
      isRod: true,
      otherTaxValues: [],
    };

    try {
      setCurrentPrint(values?.id);
      setIsPrinting(true);

      if (printDirectly) {
        await printDirectInvoice(initialvalue);
      } else {
        const data = await printInvoice(initialvalue);
        printJS({
          printable: data.html,
          type: "raw-html",
          targetStyles: ["*"],
        });
      }
      // Print using QZ Tray directly

      toast.success("Sent to printer");
      setCurrentPrint("");
      setIsPrinting(false);
    } catch (error) {
      console.log("Print error:", error);
      toast.error("Failed to send to printer");
      setCurrentPrint("");
      setIsPrinting(false);
    }
  }

  return (
    <IsPrivileged roleName={["POS", "Restaurant Orders", "Customer List"]}>
      <div
        style={{
          backgroundColor: customStyles.lighterPale,
          minHeight: "100vh",
          padding: "2rem 0",
        }}
      >
        <main className="cash-book">
          <div className="">
            <div className="p-3">
              <div>
                <Row className="mb-4">
                  <Col>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h2
                          className="mb-2 fw-bold"
                          style={{
                            color: customStyles.blackPrimary,
                            fontSize: "2rem",
                          }}
                        >
                          Order Notifications{" "}
                          <CachedIcon onClick={() => refetch()} />
                        </h2>
                        <p
                          className="mb-0"
                          style={{
                            color: customStyles.baseGrey60,
                            fontSize: "1rem",
                          }}
                        >
                          Manage pending restaurant orders
                        </p>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <div className="position-relative">
                          <RsDateRangePicker
                            placement="bottomStart"
                            value={
                              filterParams.startDate && filterParams.endDate
                                ? [
                                    parse(
                                      filterParams.startDate,
                                      "yyyy-MM-dd",
                                      new Date()
                                    ),
                                    parse(
                                      filterParams.endDate,
                                      "yyyy-MM-dd",
                                      new Date()
                                    ),
                                  ]
                                : []
                            }
                            onClean={() => clearDateRange()}
                            onOk={date => filterByDateRange(date)}
                          />
                        </div>

                        <Badge
                          bg="light"
                          text="dark"
                          className="px-3 py-3 "
                          style={{
                            backgroundColor: customStyles.lightBlue2,
                            color: customStyles.primaryBlue,
                            fontSize: "0.9rem",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}
                        >
                          {table?.length} {filterParams?.status} Orders
                        </Badge>
                        {/* <Dropdown>
                      <Dropdown.Toggle
                        variant="outline-secondary"
                        className="bg-white  border"
                        bsPrefix=""
                        type="button"
                      >
                        <FilterIcon /> Filter
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="dropdown-with-icons"
                      >
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() =>
                            setFilterParams({
                              ...filterParams,
                              status: "all",
                            })
                          }
                        >
                          All
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() =>
                            setFilterParams({
                              ...filterParams,
                              status: "pending",
                            })
                          }
                        >
                          Pending
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() =>
                            setFilterParams({
                              ...filterParams,
                              status: "completed",
                            })
                          }
                        >
                          Completed
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() =>
                            setFilterParams({
                              ...filterParams,
                              status: "canceled",
                            })
                          }
                        >
                          Canceled
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown> */}
                        <div className="d-flex justify-content-end gap-2">
                          <TabButton
                            id="all"
                            label="All"
                            isActive={filterParams.status === "all"}
                            onClick={() =>
                              setFilterParams({
                                ...filterParams,
                                status: "all",
                                stashId: "",
                              })
                            }
                          />
                          <TabButton
                            id="pending"
                            label="Pending"
                            isActive={filterParams.status === "pending"}
                            onClick={() =>
                              setFilterParams({
                                ...filterParams,
                                status: "pending",
                                stashId: "",
                              })
                            }
                          />
                          <TabButton
                            id="completed"
                            label="Completed"
                            isActive={filterParams.status === "completed"}
                            onClick={() =>
                              setFilterParams({
                                ...filterParams,
                                status: "completed",
                                stashId: "",
                              })
                            }
                          />
                          <TabButton
                            id="canceled"
                            label="Canceled"
                            isActive={filterParams.status === "canceled"}
                            onClick={() =>
                              setFilterParams({
                                ...filterParams,
                                status: "canceled",
                                stashId: "",
                              })
                            }
                          />
                        </div>
                        {/* <Tabs
                          activeKey={filterParams.status}
                          onSelect={(k) =>
                            setFilterParams({
                              ...filterParams,
                              status: k,
                              stashId: "",
                            })
                          }
                          className="mb-3"
                        >
                          <Tab eventKey="all" title="All" />
                          <Tab eventKey="pending" title="Pending" />
                          <Tab eventKey="completed" title="Completed" />
                          <Tab eventKey="canceled" title="Canceled" />
                        </Tabs> */}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row />

                <Row className="g-4">
                  {table?.map(order => (
                    <Col key={order?.id} lg={4} md={6} sm={12}>
                      <Card
                        className="h-100 shadow-sm border-0"
                        style={{
                          backgroundColor: customStyles.baseWhite,
                          borderRadius: "12px",
                          transition:
                            "transform 0.2s ease, box-shadow 0.2s ease",
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow =
                            "0 8px 25px rgba(15, 23, 42, 0.1)";
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 1px 3px rgba(0, 0, 0, 0.1)";
                        }}
                      >
                        <Card.Body className="p-4">
                          <div className="d-flex justify-content-between align-items-start mb-3">
                            <div>
                              <h5
                                className="mb-1 fw-bold"
                                style={{ color: customStyles.blackPrimary }}
                              >
                                Order {order?.id}
                              </h5>
                              <p
                                className="fw-semibold"
                                style={{
                                  color: customStyles.blackPrimary,
                                  fontSize: "0.9rem",
                                }}
                              >
                                <span>
                                  Table No: {order?.tableNumber} <br />{" "}
                                </span>
                                <span>
                                  Date:
                                  {format(
                                    new Date(order?.created_at),
                                    "dd-MMM-yyy"
                                  )}
                                </span>{" "}
                                <br />
                                <span>
                                  Time:
                                  {format(
                                    new Date(order?.created_at),
                                    "hh:mm a"
                                  )}
                                </span>
                              </p>
                            </div>
                            <Button
                              size="sm"
                              className="rounded-pill px-3  border-0"
                              style={{
                                backgroundColor: customStyles.baseGrey30,
                              }}
                              onClick={() => handlePrint(order)}
                            >
                              {isPrinting && currentPrint === order?.id
                                ? "Printing..."
                                : "Print"}
                            </Button>
                            <Badge
                              className={`rounded-pill px-3 py-2
                            ${
                              order?.status === "pending"
                                ? "bg-primary"
                                : order?.status === "completed"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                              style={{
                                backgroundColor: customStyles.bluePale,
                                color: customStyles.light,
                                fontSize: "0.75rem",
                                fontWeight: "600",
                              }}
                            >
                              {order?.status}
                            </Badge>
                          </div>

                          <div className="mb-4">
                            <div className="d-flex justify-content-between align-items-center py-2">
                              <span
                                className="fw-semibold"
                                style={{
                                  color: customStyles.blackSecondary,
                                  fontSize: "1.1rem",
                                }}
                              >
                                Items
                              </span>
                              <span
                                className="fw-semibold"
                                style={{
                                  color: customStyles.blackPrimary,
                                  fontSize: "1.1rem",
                                }}
                              >
                                Quantity
                              </span>
                            </div>
                            {order?.items?.map((item, index) => (
                              <div>
                                <div
                                  key={index}
                                  className="d-flex justify-content-between align-items-center py-2"
                                >
                                  <span
                                    style={{
                                      color: customStyles.blackSecondary,
                                      fontSize: "1.1rem",
                                    }}
                                  >
                                    {item?.Item_Name}
                                  </span>
                                  <span
                                    className="fw-semibold"
                                    style={{
                                      color: customStyles.blackPrimary,
                                      fontSize: "1.1rem",
                                    }}
                                  >
                                    <ConvertQuantity
                                      quantity={item?.Quantity}
                                      desc={item?.Item_Desc}
                                      convertNow={true}
                                      uomId={item?.uomId}
                                    />
                                  </span>
                                </div>

                                {item?.pointOfSaleComment ? (
                                  <div>
                                    <p className=" fst-italic">
                                      {item?.pointOfSaleComment}
                                    </p>
                                  </div>
                                ) : null}
                              </div>
                            ))}
                          </div>

                          <div
                            className="d-flex justify-content-between align-items-center py-3 mb-3"
                            style={{
                              borderTop: `1px solid ${customStyles.light}`,
                            }}
                          >
                            <span
                              className="fw-bold"
                              style={{
                                color: customStyles.blackPrimary,
                                fontSize: "1.1rem",
                              }}
                            >
                              Sales Rep
                              <br />
                              <span className=" fw-normal">
                                Staff ID: {order?.staff?.Staff_ID || ""}
                              </span>
                            </span>
                            <span
                              className="fw-bold"
                              style={{
                                color: customStyles.blackPrimary,
                                fontSize: "1.1rem",
                              }}
                            >
                              {order?.staff ? order?.staff?.Name : "..."}
                            </span>
                          </div>

                          {order.status === "pending" && (
                            <Button
                              disabled={order?.status !== "pending"}
                              className="w-100 fw-semibold py-3  "
                              style={{
                                borderRadius: "8px",
                                fontSize: "0.95rem",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={e => {
                                e.target.style.backgroundColor =
                                  customStyles.blackPrimary;
                              }}
                              onMouseLeave={e => {
                                e.target.style.backgroundColor =
                                  customStyles.blackSecondary;
                              }}
                              onClick={() =>
                                handleUpdateStatus({
                                  id: order?.id,
                                  status: "completed",
                                })
                              }
                            >
                              {updateMutation.isLoading &&
                              updateOrderId === order?.id
                                ? "Please wait..."
                                : "Mark as Done"}
                            </Button>
                          )}
                          {/* <Button
                          className={`w-100 fw-semibold py-3 border-0 ${
                            order?.status === "completed"
                              ? " bg-success"
                              : " bg-danger"
                          }`}
                          style={{
                            fontSize: "0.95rem",
                          }}
                        >
                          {order?.status === "completed"
                            ? "Completed"
                            : "Canceled"}
                        </Button> */}
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}

                  {!isLoading && (
                    <div>
                      {isEmpty(table) ? (
                        <NoTableItem
                          queryParams={{}}
                          title={`No ${
                            filterParams?.status === "all"
                              ? ""
                              : filterParams?.status
                          } Restaurant Order`}
                        />
                      ) : null}
                    </div>
                  )}
                </Row>
              </div>

              <div className="d-flex justify-content-center px-3 align-items-center pagination">
                <ReactPaginate
                  {...paginationOptions}
                  pageCount={Math.ceil(data?.count / queryParams.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    setQueryParams({
                      ...queryParams,
                      page: selected + 1,
                    });
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div>
            </div>
          </div>
        </main>

        <ModalLoader
          show={isLoading}
          title={`Please wait, getting ${
            filterParams?.status
          } restaurant orders...`}
        />
      </div>
    </IsPrivileged>
  );
};

export default RestaurantMenuOrderNotification;
